module.exports = __webpack_public_path__ + "static/media/joah_unboxing.af960be5.jpg";